export default {
  menus: {
    core: '核心',
    general: '通用',
    dashboard: '仪表盘',
    user: '用户',
    settings: '设置',
    devices: '设备管理',
    userDescription: '管理用户',
    settingsDescription: '应用设置',
    devicesDescription: '管理账号下已激活的设备',
  },
  routeTitles: {
    home: '首页',
    user: '用户',
    settings: '设置',
    devices: '设备管理',
    billingSuccess: '支付成功',
    login: '登录',
    register: '注册',
    forgotPassword: '找回密码',
    resetPassword: '重置密码',
    legal: '法律条款',
    subscribe: '订阅',
    notFound: '页面未找到',
  },
  common: {
    orContinueWith: '或继续使用',
    google: 'Google',
    copyright: '版权所有。',
    language: '语言',
    toggleTheme: '切换主题',
    pages: '页面',
    inThisPage: '本页内容',
    english: 'English',
    chinese: '中文',
    backToSignIn: '返回登录',
    close: '关闭',
    download: '下载',
    profile: '个人资料',
    logout: '退出登录',
    searchPlaceholder: '搜索...',
    support: '支持与反馈',
    emailSupport: '邮件支持',
  },
  auth: {
    welcomeBack: '欢迎回来',
    sessionExpired: '登录会话已过期，请重新登录。',
    signInToWorkspace: '登录 GEEKFUN Data Studio',
    email: '邮箱地址',
    emailPlaceholder: "name{'@'}company.com",
    password: '密码',
    passwordPlaceholder: '••••••••',
    verificationCode: '验证码',
    codePlaceholder: '000000',
    sendCode: '发送验证码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    useVerificationCode: '使用验证码登录',
    usePassword: '使用密码登录',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    signIn: '登录到 GEEKFUN',
    dontHaveAccount: '还没有账号？',
    signUpFree: '免费注册',
    newToGeekfun: '初次使用 GEEKFUN？',
    signUpValue: '社区版永久免费 · 旗舰版 7 天试用',
    signUp: '注册',
    passwordRequired: '请输入密码',
    codeRequired: '请输入验证码',
    googleSignInFailed: 'Google 登录失败，请重试。',
    googleSignInNotCompleted: 'Google 登录未完成，请重试。',
    createAccount: '创建您的账号',
    joinGeekfun: '加入 GEEKFUN 开始管理您的数据',
    fullName: '姓名',
    fullNamePlaceholder: '张三',
    passwordMinLength: '至少8个字符',
    agreeToTerms: '我同意',
    terms: '服务条款',
    and: '和',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
    byClickingContinue: '点击继续即表示您同意我们的',
    createAccountButton: '创建账号',
    creatingAccount: '创建中…',
    alreadyHaveAccount: '已有账号？',
    logIn: '登录',
    fullNameRequired: '请输入姓名',
    validEmailRequired: '请输入有效的邮箱地址',
    passwordMin8: '密码至少需要8个字符',
    codeSentToEmail: '验证码已发送到您的邮箱',
    emailRequiredFirst: '请先输入有效的邮箱地址',
    failedSendCode: '发送验证码失败，请重试。',
    mustAgreeTerms: '您必须同意服务条款和隐私政策',
    registrationFailed: '注册失败，请重试。',
    mustAgreeTermsBeforeContinue: '继续之前必须同意服务条款和隐私政策',
    googleRegistrationFailed: 'Google 注册失败，请重试。',
    forgotPasswordTitle: '忘记密码？',
    forgotPasswordDesc: '输入与您的账号关联的邮箱地址，我们将向您发送密码重置链接。',
    resetLinkSent: '如果该邮箱存在账号，重置链接已发送。请查收您的收件箱。',
    sendResetLink: '发送重置链接',
    sendAgain: '重新发送',
    validatingResetLink: '正在验证您的重置链接...',
    linkExpiredOrInvalid: '链接已过期或无效',
    linkExpiredDesc: '此密码重置链接无效或已过期。请重新申请。',
    requestNewResetLink: '申请新的重置链接',
    linkAlreadyUsed: '链接已使用',
    linkAlreadyUsedDesc: '此密码重置链接已被使用。如需再次重置密码，请申请新链接。',
    passwordReset: '密码已重置！',
    passwordResetSuccess: '您的密码已成功重置。',
    signInWithNewPassword: '使用新密码登录',
    setNewPassword: '设置新密码',
    chooseStrongPassword: '请选择至少8个字符的强密码。',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    resetPassword: '重置密码',
    passwordsDoNotMatch: '两次密码输入不一致',
    somethingWentWrong: '出错了，请重试。',
    resetLinkAlreadyUsed: '此重置链接已被使用，请重新申请。',
    requestNewResetLinkError: '出错了，请重新申请重置链接。',
    loginFailed: '账号不存在或密码错误，请重试',
  },
  handoff: {
    loginSuccessful: '登录成功！',
    accountReady: '您的账号已准备就绪。是否打开 {app}？',
    continueToWeb: '继续使用网页版',
    openInApp: '打开 {app}',
  },
  brand: {
    name: 'GEEKFUN Data Studio',
    tagline: '专业的高性能团队数据管理套件。',
  },
  dockitBrand: {
    name: 'DocKit',
    tagline: '支持 Elasticsearch、OpenSearch 和 DynamoDB 的 NoSQL 客户端。',
  },
  sqlkitBrand: {
    name: 'SqlKit',
    tagline: '支持 PostgreSQL、MySQL、SQL Server 等数据库的 SQL 客户端。',
  },
  legal: {
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    refundPolicy: '退款政策',
    consentRequired: '需要同意',
    consentDescription: '在创建账号之前，请阅读并接受我们的法律政策。',
    consentSummary: '同意即表示您确认已阅读并接受：',
    consentItem1: '我们如何收集和使用您的个人信息',
    consentItem2: '您对数据的权利',
    consentItem3: '管理您使用我们服务的条款',
    agreeAndContinue: '同意并继续',
    decline: '拒绝',
  },
  profile: {
    title: '个人资料',
    avatar: '头像',
    avatarDescription: '您的个人头像',
    changeAvatar: '更换',
    removeAvatar: '删除',
    avatarConstraints: '支持 JPEG、PNG 或 WebP 格式，最大 2MB。',
    information: '个人信息',
    informationDescription: '更新您的个人资料',
    username: '用户名',
    usernamePlaceholder: 'zhangsan',
    usernameDescription: '3-30 个字符，仅支持字母、数字和下划线。',
    fullName: '姓名',
    fullNamePlaceholder: '张三',
    email: '邮箱',
    emailDescription: '邮箱地址不可修改。',
    saveChanges: '保存更改',
    updateSuccess: '资料更新成功！',
    validation: {
      usernameMin: '用户名至少需要 3 个字符',
      usernameMax: '用户名最多 30 个字符',
      usernamePattern: '用户名只能包含字母、数字和下划线',
      fullNameMax: '姓名最多 100 个字符',
      avatarTooLarge: '图片大小不能超过 2MB',
      avatarInvalidType: '图片必须是 JPEG、PNG 或 WebP 格式',
    },
  },
  settings: {
    title: '设置',
    security: '安全',
    preferences: '偏好设置',
    notifications: '通知',
    changePassword: '修改密码',
    changePasswordDescription: '更新密码以保护您的账户安全',
    currentPassword: '当前密码',
    currentPasswordPlaceholder: '••••••••',
    newPassword: '新密码',
    newPasswordPlaceholder: '••••••••',
    newPasswordDescription: '至少 8 个字符',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '••••••••',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    passwordChanged: '密码修改成功！',
    displayPreferences: '显示偏好',
    displayPreferencesDescription: '自定义应用的外观和感觉',
    language: '语言',
    selectLanguage: '选择语言',
    theme: '主题',
    selectTheme: '选择主题',
    themeSystem: '跟随系统',
    themeLight: '浅色',
    themeDark: '深色',
    preferencesSaved: '偏好设置已保存！',
    emailNotifications: '邮件通知',
    emailNotificationsDescription: '管理您的邮件通知偏好',
    emailNotificationsLabel: '邮件通知',
    emailNotificationsDescription2: '接收有关账户活动和更新的通知',
    marketingEmails: '营销邮件',
    marketingEmailsDescription: '接收有关新功能和促销活动的邮件',
    notificationsSaved: '通知设置已保存！',
    saveChanges: '保存更改',
    changePasswordFailed: '修改密码失败',
    saveFailed: '保存设置失败',
    dangerZone: '危险操作',
    deleteAccount: '注销此账户',
    deleteAccountDescription:
      '注销账户后无法恢复，请务必慎重。此操作将永久删除您的个人资料、订阅、交易记录、试用及个人数据。',
    deleteConfirmTitle: '注销账户？',
    deleteConfirmDescription:
      '将永久删除您的账户、订阅、交易记录、试用及个人数据。若您有进行中的订阅，请先取消订阅。',
    deleteTypeConfirm: '输入 DELETE 以确认',
    deleteFailed: '注销失败',
    validation: {
      currentPasswordRequired: '当前密码不能为空',
      newPasswordMin: '新密码至少需要 8 个字符',
      passwordsMatch: '两次输入的密码不一致',
    },
  },
  subscribe: {
    title: 'GEEKFUN Data Studio Ultimate',
    status: {
      checking: '正在检查订阅状态...',
      checkout: '正在打开安全支付页面...',
      trial: '正在开启免费试用...',
    },
    changePlan: '切换套餐',
    continueToPayment: '继续支付',
    goToDashboard: '前往控制台',
    trialUsed: {
      title: '免费试用已使用',
      description: '该账号的 7 天免费试用已使用完毕，订阅后即可继续使用全部 Ultimate 功能。',
      subscribeCta: '立即订阅',
    },
    errors: {
      title: '无法继续',
      loadFailed: '未能获取订阅状态，请重试。',
      checkoutFailed: '未能发起支付，请重试。',
      trialFailed: '未能开启免费试用，请重试。',
      retry: '重试',
    },
  },
  billing: {
    title: '账单与订阅',
    description: '管理您的订阅并查看交易历史',
    notAvailable: '暂无',
    mor: {
      creem: '款项由 Creem（Armitage Labs OÜ，我们的 Merchant of Record 登记卖方）处理，负责收款、税务合规、开票与退款。',
      waffo: '款项由 Waffo（Waffo.com Limited，中国香港，我们的 Merchant of Record 登记卖方）处理，负责收款、税务合规、开票与退款。',
    },
    trial: {
      title: '免费试用',
      description: '您的 7 天旗舰版免费试用',
      trialEnd: '试用结束',
      cancelTrial: '取消试用',
      canceling: '取消中...',
      subscribe: '立即订阅',
      canceled: '试用已取消',
      cancelConfirmTitle: '取消免费试用？',
      cancelConfirmDescription: '您确定要取消免费试用吗？',
      cancelConfirmWarning: '取消后您将立即失去所有旗舰版功能的访问权限。',
      keepTrial: '继续试用',
      confirmCancel: '取消试用',
    },
    plan: {
      community: '社区版',
      ultimate: '旗舰版',
      free: '免费',
    },
    status: {
      pending: '待支付',
      trialing: '试用中',
      active: '活跃',
      past_due: '逾期未付',
      canceled: '已取消',
      expired: '已过期',
    },
    billing: {
      monthly: '月付',
      yearly: '年付',
      month: '月',
      year: '年',
    },
    details: {
      amount: '金额',
      nextBilling: '下次扣款',
      trialEnd: '试用结束',
      accessUntil: '访问至',
    },
    actions: {
      loading: '加载中...',
      managePayment: '管理支付',
      completePayment: '完成支付',
      cancelSubscription: '取消订阅',
    },
    support: {
      cny: '人民币套餐的变更请发邮件联系我们。',
      failed: '支付渠道已更新，我们这边没有同步成功。请发邮件，我们来处理。',
    },
    transactions: {
      title: '交易历史',
      description: '查看您的付款记录',
      empty: '暂无交易记录',
      charge: '付款',
      refund: '退款',
      status: {
        success: '成功',
        failed: '失败',
        pending: '处理中',
      },
    },
    cancel: {
      title: '取消订阅？',
      description: '您确定要取消订阅吗？',
      warning: '您将保留访问权限至 {date}，之后订阅正式结束。',
      refundPolicy:
        '由于付款前已提供 7 天免费试用，付款完成后所有款项均不予退款。退款政策的详情与例外情形请参阅退款政策。',
      scheduledTitle: '已预约取消',
      scheduledNotice: '订阅将于 {date} 结束且不再续费。到期前您可继续使用全部功能。',
      accessUntilNotice: '您的订阅已取消，您可继续使用至 {date}。',
      back: '保留订阅',
      confirm: '取消订阅',
      canceling: '取消中...',
    },
    noSubscription: {
      title: '暂无活跃订阅',
      description: '您还没有活跃订阅。升级到旗舰版即可访问所有高级功能。',
      cta: '立即订阅',
    },
    success: {
      title: '支付成功！',
      description: '感谢您订阅 GEEKFUN 数据工作室旗舰版。',
      verifying: '正在验证您的支付...',
      errorTitle: '验证失败',
      invalidRedirect: '无效的重定向。请检查您的账单状态。',
      activationPending:
        '您的付款可能仍在处理中。若已扣款，订阅将在不久后激活。请稍后前往账单页面查看。',
      whatHappensNext: '接下来：',
      trialStarted: '您的7天免费试用已开始',
      fullAccess: '您现在可以使用所有旗舰版功能',
      manageBilling: '您可以随时在账单页面管理您的订阅',
      goToDashboard: '前往仪表盘',
      viewBilling: '查看账单',
      goToBilling: '前往账单',
    },
  },
  dashboard: {
    subscription: '订阅',
    quickLaunch: '快速启动',
    snippets: '代码片段',
    aiAssistants: 'AI 助手',
    files: '文件',
    connections: '连接',
    trendFromLastMonth: '较上月 +0%',
    trendSinceLastHour: '较上小时 +0',
    comingSoon: '即将上线',
    upgrade: '升级到旗舰版',
    manage: '管理订阅',
    trialDaysLeft: '试用剩余 {days} 天',
    choosePlan: '选择付费周期',
    savePercent: '立省 {percent}%',
    pendingCheckoutHint: '上次发起的支付尚未完成，可随时继续付款。',
    startNewCheckout: '重新发起支付',
    unlockLabel: '升级旗舰版，解锁',
    featureAi: 'AI 助手 — DocKit 与 SqlKit 自定义 Agent 与 LLM 配置',
    featureNl2sql: 'AI NL2SQL — 自然语言直达 SQL 与 PartiQL',
    featureAgent: 'Data Studio Agent — 用自然语言操作你的数据库',
    featureMcp: 'MCP Servers — 接入 Claude Code、Cursor、Codex 等任意 MCP 客户端',
    featureCluster: '集群管理 — 节点/分片/索引监控与 ER 图',
    featureImportExport: '导入/导出 — 批量迁移，支持百万行数据',
    featureSsh: 'SSH 隧道与代理 — 支持 AWS SSO/IAM 企业认证',
    featureSupport: '优先支持',
    dockitDesc: 'NoSQL GUI · 监控 · PartiQL',
    sqlkitDesc: 'SQL 编辑器 · 70+ 数据库 · 历史记录',
    agentDesc: '让 AI 编码代理安全访问你的数据库',
    serverlessinsightDesc: '跨云 Serverless 基础设施',
    downloadApps: '下载桌面应用',
    downloadAppsDesc: 'DocKit 与 SqlKit · macOS / Windows',
    devices: '设备数',
    trustCancel: '随时取消，权益保留至周期末',
    trustFreeForever: '社区版永久免费',
    trustTrial: '或先免费试用 7 天',
    openDockit: '打开 DocKit',
    openSqlkit: '打开 SqlKit',
    launching: '启动中…',
    launchSteps: {
      subscription: '正在检查订阅…',
      session: '正在验证登录状态…',
      opening: '正在打开 {app}…',
    },
    appNotInstalled: {
      title: '应用未安装',
      description: '{app} 似乎尚未安装在您的设备上。',
      download: '前往下载页面',
      cancel: '取消',
    },
  },
  notFound: {
    title: '页面不存在',
    description: '您访问的页面无法找到',
    backHome: '返回首页',
  },
  devices: {
    title: '设备管理',
    description:
      '订阅最多可在 3 台设备上激活（试用期为 1 台）。达到上限后，在新设备登录时可以选择替换其中一台。',
    slotUsage: '已使用 {used}/{limit} 台',
    empty: '暂无设备。从桌面应用登录后，设备会显示在这里。',
    thisDevice: '本机',
    statusRevoked: '已解绑',
    activatedAt: '激活于',
    lastSeenAt: '最后活跃',
    neverSeen: '从未活跃',
    unbind: '解绑',
    selectTitle: '选择要解绑的设备',
    selectDescription:
      '被解绑的设备立即失去访问权限，离线状态最多还可维持 30 天。只要有空闲槽位，随时可以在该设备上重新登录。',
    confirmUnbind: '解绑设备',
    loadFailed: '加载设备列表失败',
    unbindFailed: '解绑设备失败',
  },
}
